import { QRCode } from 'react-qrcode-logo'
import { Card, CardContent, CardFooter } from '../../@/components/ui/card'
import { Button } from '../../@/components/ui/button'

const APP_DOWNLOAD_URL = 'https://www.hitemupapp.com/get'

const AppDownloadQRCard = ({ openDownloadModal }: { openDownloadModal: () => void }) => {
	return (
		<Card className="w-56 mx-auto">
			<CardContent className="p-3 flex flex-col items-center">
				<QRCode
					value={APP_DOWNLOAD_URL}
					logoImage="/icon.png"
					qrStyle="dots"
					fgColor="#00A687"
					bgColor="#FFFFFF"
					eyeColor="#000000"
					removeQrCodeBehindLogo
					logoHeight={30}
					logoWidth={30}
					eyeRadius={10}
				/>
			</CardContent>
			<CardFooter>
				<Button className="w-full" onClick={openDownloadModal}>
					Download App
				</Button>
			</CardFooter>
		</Card>
	)
}

export default AppDownloadQRCard
